import { FC } from 'react'
import { Box, Button, Divider, Grid, Typography } from '@mui/material'
import CategoryIcon from '@mui/icons-material/Category';
import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import categoria_prueba from '../../../assets/image/categoria_prueba.png';
import { useSearcherStore } from '../../../hooks/useSearcherStore';
import { moneyFormat } from '../../../toolbox/helpers/money-helpers';
import '../../../assets/styles/searchKFC.css'
import CloseIcon from '@mui/icons-material/Close'
import { useAuthStore } from '../../../hooks/useAuthStore';
import { useShoppingCartStore } from '../../../hooks/useShoppingCartStore';

interface SearcherV3PopoverProps {
    setShowSearcher: React.Dispatch<React.SetStateAction<boolean>>
    handleSelectProduct: (idproduct: number) => Promise<void>
    showMoreProduct: (product: any) => void
}

export const SearcherV3Popover: FC<SearcherV3PopoverProps> = (props) => {
    const { setShowSearcher, handleSelectProduct, showMoreProduct } = props

    const { dataSearch } = useSearcherStore()

    return (
        <div style={{
            position: 'fixed',
            top: 70,
            left: '60%',
            minWidth: '400px',
            height: '350px',
            backgroundColor: '#f4f4f4',
            zIndex: 2,
            borderRadius: '10px',
            padding: '10px',
            overflowY: 'auto',
            boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.3)',
        }}>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button style={{ cursor: 'pointer', background: 'none', border: 'none' }} onClick={() => setShowSearcher(false)}>
                    <CloseIcon />
                </button>
            </div>

            <div>
                {
                    dataSearch.category_product?.map(category =>
                        <div style={{ width: '95%', margin: 'auto', cursor: 'pointer' }}
                        // onClick={() => getFilterProductsApi(category)}
                        >
                            <CategoryIcon sx={{ color: '#848485', marginRight: '5px', fontSize: 'large' }} />
                            <p>{category.name}</p>
                            {
                                category.subcategory_product?.map(subcategory =>
                                    <div style={{ width: '95%', margin: 'auto', borderBottom: '1px solid #848485', cursor: 'pointer' }}>
                                        <SubdirectoryArrowRightIcon sx={{ color: '#848485', marginRight: '5px', fontSize: 'large' }} />
                                        <p>{subcategory.name}</p>
                                    </div>
                                )
                            }
                        </div>
                    )
                }
            </div >

            <div style={{ backgroundColor: '#DEDFDE', width: '95%', margin: 'auto', borderBottom: '1px solid #848485', marginTop: '5px' }}>
                <p>PRODUCTOS</p>
            </div>

            <div style={{ display: 'flex', flexWrap: 'wrap', margin: 'auto', justifyContent: 'center' }}>
                {
                    dataSearch?.products?.length > 0
                        ?
                        dataSearch?.products?.map((product) =>
                            <div style={{
                                width: '195px', margin: '5px', display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                <img style={{ width: '60%' }} src={categoria_prueba} alt="Categoria Prueba" />
                                <Divider sx={{ width: '80%', height: '1px', backgroundColor: 'rgba(0, 0, 0, 0.3)', marginTop: '5px' }} />
                                <div style={{ padding: '10px' }}>

                                    <Grid item sx={{ width: '100%', marginLeft: 'auto' }}>
                                        {
                                            product.offerprice_product && (
                                                <Typography fontWeight={'500'} fontSize={'12px'} color={'red'} style={{ textDecoration: 'line-through', marginRight: '10px' }}>{moneyFormat(product.price, '$') || '-----'}</Typography>
                                            )
                                        }
                                        <Typography fontWeight={'500'} fontSize={'12px'}>
                                            {
                                                product.offerprice_product ? moneyFormat(product.offerprice_product, '$') :
                                                    (product.price ? moneyFormat(product.price, '$') : '-----')
                                            }
                                        </Typography>
                                    </Grid>

                                    <Grid item sx={{ width: '100%', marginLeft: 'auto', display: 'flex', flexDirection: 'column' }}>
                                        <Typography fontWeight={'600'} fontSize={'14px'}>{product.name_product}</Typography>
                                        <Typography fontSize={'12px'}>{product.description_product || '-----'}</Typography>
                                    </Grid>

                                    <Grid item sx={{ width: '100%' }}>
                                        <Button sx={{ border: '2px solid #D0D0D0', borderRadius: '20px', fontSize: '7px', color: '#707070', height: '25px', margin: '5px' }}
                                            onClick={() => showMoreProduct(product)}
                                        >Ver más</Button>
                                        <Button
                                            onClick={() => handleSelectProduct(product.idproduct)}
                                            sx={{
                                                borderRadius: '20px',
                                                fontSize: '7px',
                                                backgroundColor: '#91CBF9',
                                                color: '#fff',
                                                height: '25px'
                                            }}>Añadir al carrito</Button>
                                    </Grid>
                                </div>
                            </div>
                        )
                        :
                        <Grid item container xs={12}>
                            <Box sx={{ backgroundColor: 'rgba(224, 224, 224, 0.5)', margin: '10px', padding: '20px', borderRadius: '10px', height: '270px', justifyContent: 'center', alignItems: 'center', display: 'flex', width: '100%', textAlign: 'center' }} >
                                {"NO SE ENCONTRARON PRODUCTOS"}
                            </Box>
                        </Grid>
                }
            </div>
        </div>
    )
}